module.exports = "/virtual-football-league/img/amblems/left/logos/Leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Leverkusen.png
// module id = 2105
// module chunks = 4